export const REGEX = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^\d{10}$/,
  rfc: /^[A-Z0-9]{12,13}$/,
  zipCode: /^\d{5}$/,
};
